<!-- 注册 -->
<template>
      <div class="container">
    <header>
      <router-link to="/"><img src="./../assets/logo.png" alt=""></router-link>
      <span>欢迎来到广州燊业互联网有限公司</span>
    </header>
    <section class="content">
      <div class="sign-wrap">
        <form>
          <div class="name">
            <p class="phone"><span>手机号:</span><input  type="text" placeholder="手机号" /><span class="getCode" @click="getCode">获取验证码</span></p>
            <p><span>验证码:</span><input type="text" placeholder="验证码"/></p>
            <p><span>用户名:</span><input type="text" placeholder="勿使用特殊字符"/></p>
            <p><span>密码：</span><input type="text" placeholder="设置密码"/></p>
            <p><span>密码：</span><input type="text" placeholder="确认密码"/></p>
          </div>
          <button @click="sign($event)">注册</button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},
  methods: {
    sign: function() {
      console.log("注册");
      this.$router.push({
        path: "/"
      });
    },
    getCode: function(event) {
      event.preventDefault();
      console.log("获取验证码");
    }
  }
};
</script>
<style scoped>
.container {
  background-color: #f5f5f5;
}
header {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
}
header img {
  height: 75px;
}
header span {
  color: #00a0e9;
  font-size: 18px;
}
.content {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  background: #fff;
}
.content .sign-wrap {
  width: 480px;
  height: 494px;
  font-size: 0;
  margin: 100px 0 246px 0;
  border: 1px solid #e6e6e6;
  display: inline-block;
}
.content .sign-wrap .name {
  margin-top: 21px;
}
.content .sign-wrap .name p {
  margin-bottom: 21px;
  font-size: 18px;
  color: #333;
}
.content .sign-wrap .name p input {
  width: 338px;
  height: 48px;
  padding-left: 21px;
  font-size: 18px;
  color: #ccc;
}
.content .sign-wrap .name p > span {
  margin-right: 17px;
  font-size: 18px;
}
.content .sign-wrap .name .phone {
  position: relative;
}
.content .sign-wrap .name .phone .getCode {
  width: 96px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 7px;
  font-size: 14px;
  background: #e6e6e6;
  border-radius: 2px;
  color: #b3b3b3;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  border: 1px solid #ccc !important;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}
button {
  width: 230px;
  height: 48px;
  font-size: 18px;
  line-height: 48px;
  text-align: center;
  background-color: #00a0e9;
  border: none;
  color: #fff;
}
.content .sign-wrap .extra {
  margin-top: 42px;
}
.content .sign-wrap .extra > a {
  font-size: 14px;
  color: #333;
}
.content .sign-wrap .extra > a:first-child {
  margin-right: 71px;
}
.content .sign-wrap .extra .toSign {
  color: #00a0e9;
}
</style>


// WEBPACK FOOTER //
// src/views/Sign.vue